import React from "react";
import Carousel from "nuka-carousel";
// import { SocialShare } from "@quintype/components";
import get from "lodash/get";
import { connect } from "react-redux";
import PT from "prop-types";

// import { SocialShareTemplate } from "../social-share";
import "./breaking-news-view.m.css";

function breakingNewsItem(story, props) {
  function langClass() {
    if (props.publisherAttributes.lang === "en") {
      return "en-breaking-news";
    } else if (props.publisherAttributes.lang === "hi") {
      return "hi-breaking-news";
    }
  }

  return (
    <div styleName="breaking-news-item" key={story.id}>
      <a
        styleName="breaking-news-header"
        className={langClass()}
        href={story.metadata && story.metadata["linked-story-slug"]}
        target="_blank"
        rel="noopener noreferrer"
      >
        {story.headline}
      </a>

      {/* <SocialShare
        template={SocialShareTemplate}
        title={story.headline}
        url={story.metadata && story.metadata["linked-story-slug"]}
        // hashtags={story && story.tags.map(tag => tag.name).toString()}
        color="#056ff7"
      /> */}
    </div>
  );
}

function BreakingNewsBase(props) {
  if (props.pageType !== "home-page" || (props.breakingNewsLoaded && props.breakingNews.length === 0)) {
    return <span />;
  }

  const getBreakingNewsTitle = () => {
    if (props.publisherAttributes.lang === "en") {
      return "Headline";
    } else if (props.publisherAttributes.lang === "hi") {
      return "मुख्य खबरें";
    } else {
      return "تازہ ترین";
    }
  };
  function getBreakingNewsTitleStyle() {
    if (props.publisherAttributes.lang === "ur") {
      return "ur-breaking-news-title";
    } else {
      return "breaking-news-title";
    }
  }
  return (
    <div styleName={props.publisherAttributes.lang === "ur" ? "ur-breaking-news-container" : "breaking-news-container"}>
      <div styleName={getBreakingNewsTitleStyle()}>{getBreakingNewsTitle()}</div>
      <Carousel
        transitionMode="fade"
        cellAlign="left"
        slidesToShow={1}
        wrapAround={true}
        slideIndex={0}
        heightMode="current"
        slidesToScroll={1}
        withoutControls={true}
        autoplay={true}
        autoplayInterval={4000}
        initialSlideHeight={1}
      >
        {props.breakingNewsLoaded ? (
          props.breakingNews.map(story => breakingNewsItem(story, props))
        ) : (
          <div styleName="breaking-news-item">
            <div styleName="breaking-news-header"> </div>
          </div>
        )}
      </Carousel>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    pageType: get(state, ["qt", "pageType"], []),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], "")
  };
}

BreakingNewsBase.propTypes = {
  breakingNews: PT.array,
  breakingNewsLoaded: PT.bool,
  pageType: PT.string,
  publisherAttributes: PT.object
};
breakingNewsItem.propTypes = {
  publisherAttributes: PT.object
};

export const BreakingNewsView = connect(
  mapStateToProps,
  null
)(BreakingNewsBase);
